import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsMultiSelectModule } from '@lcs/shared/multi-select';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { FormatSecondsPipeModule } from 'src/app/pipes/format-seconds/format-seconds-pipe.module';
import { MacAddressPipeModule } from 'src/app/pipes/mac-address-pipe/mac-address-pipe.module';
import { BulkConfigureExtensionsDialogComponent } from './bulk-configure-extensions-dialog.component';

@NgModule({
   declarations: [BulkConfigureExtensionsDialogComponent],
   imports: [
      CommonModule,
      EntitySelectModule,
      MatDialogModule,
      MatButtonModule,
      MatCheckboxModule,
      MatFormFieldModule,
      MatIconModule,
      MatInputModule,
      FormatPhoneNumbersPipeModule,
      FormatSecondsPipeModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsMultiSelectModule,
      LcsResponsiveTableModule,
      ReactiveFormsModule,
      MacAddressPipeModule,
      AppRoutingModule,
   ],
   providers: [BulkConfigureExtensionsDialogComponent],
})
export class BulkConfigureExtensionsDialogModule {}
